export function sessionExpired(expiresAt, now = Date.now()) {
    const expiry = Date.parse(expiresAt);
    return !Number.isFinite(expiry) || now >= expiry;
}
// Timers alone are insufficient when a mobile browser suspends the page.
export function watchSession(options) {
    const now = options.now ?? Date.now;
    let locked = false, disposed = false;
    const check = (immediate = true) => {
        if (disposed)
            return true;
        if (!locked && sessionExpired(options.expiresAt, now())) {
            locked = true;
            options.expire(immediate);
        }
        return !locked;
    };
    const event = (e) => {
        if (!check()) {
            e.preventDefault();
            e.stopImmediatePropagation();
        }
    };
    const windowEvents = ["focus", "pageshow", "pointerdown", "keydown", "click", "submit"];
    const documentEvents = ["visibilitychange", "resume"];
    for (const name of windowEvents)
        options.window.addEventListener(name, event, { capture: true });
    for (const name of documentEvents)
        options.document.addEventListener(name, event, { capture: true });
    check(false);
    const timer = (options.schedule ?? setTimeout)(() => check(), Math.max(0, Math.min(2147483647, Date.parse(options.expiresAt) - now())) || 0);
    return () => {
        disposed = true;
        (options.cancel ?? clearTimeout)(timer);
        for (const name of windowEvents)
            options.window.removeEventListener(name, event, { capture: true });
        for (const name of documentEvents)
            options.document.removeEventListener(name, event, { capture: true });
    };
}
